export enum SearchAnalyticsEvents {
  SEARCH_RESULT_CLICK = 'search_result_click',
  SENDS_QUESTION = 'send_question',
  TYPES_IN_THE_SEARCHBAR = 'type_in_searchbar',
  SEARCH_CLICK = 'search_click',
  SEARCH = 'search',
}
